export default __webpack_public_path__ + "static/media/services_step_roofing.0a6aba88.svg";